import { documentTypeOptions } from './constants';

export const envioVoucher = { email: '', repeatEmail: '' };

export const contactoNoviaja = {
  name: '',
  lastname: '',
  codePhone: '54',
  caracteristicPhone: '',
  phone: '',
};

export function generateEmptyPassengers({ elementSelected }) {
  const passengerCount =
    elementSelected?.clientesCotizados?.clienteCotizacion?.length || 0;

  const emptyPassengers = [];

  for (let i = 0; i < passengerCount; i++) {
    const passenger = {
      document_type: 'DNI',
      document_number: '',
      birthdate: '',
      name: '',
      last_name: '',
      country: '540',
    };

    // Solo el primer pasajero tiene campos de teléfono
    if (i === 0) {
      passenger.codePhone = '54';
      passenger.caracteristicPhone = '';
      passenger.phone = '';
    }

    emptyPassengers.push(passenger);
  }

  return emptyPassengers;
}

export const obtainArrayErrorsPassengers = data => {
  let errors = [];
  data.forEach(dat => {
    let newObject = {};
    Object.keys(dat).forEach(key => {
      newObject[key] = {
        error: false,
        text: '',
      };
    });
    errors.push(newObject);
  });
  return errors;
};

export const errorInPssenger = passanger => {
  let error = false;
  Object.keys(passanger).forEach(key => {
    if (passanger[key].error === true) {
      error = true;
    }
  });
  return error;
};
export const errorInNoViaja = errorNoViaja => {
  let error = false;
  Object.keys(errorNoViaja).forEach(key => {
    if (errorNoViaja[key].error === true) {
      error = true;
    }
  });
  return error;
};
export const errorInVoucher = errorVoucher => {
  let error = false;
  Object.keys(errorVoucher).forEach(key => {
    if (errorVoucher[key].error === true) {
      error = true;
    }
  });
  return error;
};

export const errorInTerminos = errorTerminos => {
  let error = false;
  Object.keys(errorTerminos).forEach(key => {
    if (errorTerminos[key].error === true) {
      error = true;
    }
  });
  return error;
};

export const firstError = errors => {
  let nameError = null;
  Object.keys(errors).forEach(key => {
    if (errors[key].error === true && nameError === null) {
      nameError = key;
    }
  });
  return nameError;
};

export const firstComponentError = (
  errorPssengers,
  errorVoucher,
  errorNoViaja,
  errorTerminos
) => {
  let encontreError = false;
  let passangerFirst = [];
  errorPssengers;
  for (let i = 0; i < errorPssengers.length; i++) {
    passangerFirst.push(false);
  }

  let firstComponenetError = {
    passenger: passangerFirst,
    contact: false,
    noViaja: false,
    franquicia: false,
    acceptedTerms: false,
  };
  errorPssengers.forEach((passanger, index) => {
    Object.keys(passanger).forEach(key => {
      if (passanger[key].error === true && !encontreError) {
        encontreError = true;
        firstComponenetError.passenger[index] = true;
      }
    });
  });
  if (!encontreError) {
    Object.keys(errorNoViaja).forEach(key => {
      if (errorNoViaja[key].error === true) {
        encontreError = true;
        firstComponenetError.noViaja = true;
      }
    });
  }
  if (!encontreError) {
    Object.keys(errorVoucher).forEach(key => {
      if (errorVoucher[key].error === true) {
        encontreError = true;
        firstComponenetError.contact = true;
      }
    });
  }
  if (!encontreError) {
    Object.keys(errorTerminos).forEach(key => {
      if (errorTerminos[key].error === true) {
        encontreError = true;
        firstComponenetError.acceptedTerms = true;
      }
    });
  }

  return firstComponenetError;
};

export function obtenerFechas(array) {
  var fechas = [];
  for (var i = 0; i < array.length; i++) {
    fechas.push(array[i].fechaNacimiento);
  }
  return fechas;
}

export function convertirFormatoFechas(arrayFechas) {
  var nuevoArrayFechas = [];

  for (var i = 0; i < arrayFechas.length; i++) {
    var fecha = arrayFechas[i];
    var partes = fecha.split('/'); // Dividir la fecha en partes: día, mes, año
    var fechaFormateada = partes[2] + '-' + partes[1] + '-' + partes[0]; // Reorganizar las partes en el nuevo formato
    nuevoArrayFechas.push(fechaFormateada);
  }

  return nuevoArrayFechas;
}

export function formatDate(dateString) {
  const [year, month, day] = dateString.split('-');
  return `${day}/${month}/${year}`;
}

export const generatePassangersArr = (formPassengers, noViaja, email) => {
  const transformedPassengers = [];

  for (const passenger of formPassengers) {
    const transformedPassenger = {
      document_type:
        documentTypeOptions.find(
          opt => opt.formikValue === passenger.document_type
        )?.backendValue || '1',
      document_number: passenger.document_number?.trim(),
      birthdate: formatDate(passenger.birthdate),
      name: passenger.name,
      last_name: passenger.last_name,
      email: email,
      phone: `${formPassengers[0].codePhone || ''}${
        formPassengers[0].caracteristicPhone || ''
      }${formPassengers[0].phone || ''}`.slice(0, 20),
      country: passenger.country,
      contact: `${noViaja.name} ${noViaja.lastname}`,
      contact_phone: `${noViaja.codePhone || ''}${
        noViaja.caracteristicPhone || ''
      }${noViaja.phone || ''}`.slice(0, 20),
    };

    transformedPassengers.push(transformedPassenger);
  }

  return transformedPassengers;
};
